import { render } from "./UPSWorldShip.vue?vue&type=template&id=4820d52a"
import script from "./UPSWorldShip.vue?vue&type=script&lang=js"
export * from "./UPSWorldShip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__